<script>
import vue2Dropzone from "vue2-dropzone";
import { doc, getFirestore, updateDoc } from 'firebase/firestore';

import "vue2-dropzone/dist/vue2Dropzone.min.css";
import firebase from "firebase/compat/app";
import handyUploader from "handy-uploader/src/components/handyUploader";
import LoginComponent from "@/components/Auth/Login";
import axios from "axios";
import SignupComponent from "@/components/Auth/Signup";
const uuid = require("uuid");
import { getStorage, ref, uploadString, getDownloadURL } from "firebase/storage";

export default {
  metaInfo: {
    title: "AddItem",
    titleTemplate: "Strapp - New Item ➕",
    content:
      "An online rental marketplace where you can rent out your household items and equipment to others for short term periods.",
    htmlAttrs: { lang: "en" },
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
    ],
  },

  components: {
    // Register: () => import('./Register.vue'),
    handyUploader,
    LoginComponent,
    SignupComponent,
    vueDropzone: vue2Dropzone,
  },

  data() {
    return {
      state: "add-item-auth",
      condition: null,
      snackbar: false,
      text: "",
      event: "",
      salesValue: '',
      loginDialog: false,
      continueAddItemAfterLogin: false,
      focus: "",
      signupDialog: false,
      addItem: false,
      itemImages: [],
      welcomeDialog: false,
      period: "Day(s)",
      // userstate: false,
      enabledDeposit: false,
      enabledDelivery: false,
      recomendedWeekly: "00",
      recomendedMonthly: "00",
      checkbox: false,
      successDialog: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        // maxFilesize: 0.5,
        addRemoveLinks: true,
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag Images or Click Here</p>
          `,
        headers: { "My-Awesome-Header": "header value" },
      },
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Be more descriptive.",
        emailMatch: () => "The email and password you entered don't match",
      },
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: true,
      },
      periodLength: "1",
      custom: true,
      max: 500,
      minDays: 0,
      streetName: '',
      streetNumber: '',
      suburb: '',
      postalCode: '',
      province: '',
      lat: 0,
      long: 0,
      country: '',
      e4: 1,
      dialog: false,
      serialNumber: "",
      allCategories: [
        "Technology",
        "Transportation",
        "Household living",
        "DIY",
        "Exercise",
        "Music and Audio",
      ],
      allConditions: [
        "Like New, no signs of use",
        "Good, Minor signs of use, everything works",
        "Fair, Medium signs of use, everything works",
        "Worn, Heavy signs of use, everything works",
      ],
      periodOptions: ["Day(s)", "Week(s)", "Month(s)"],
      category: null,
      area: "",
      itemName: "",
      newShipment: {
    "collection_address": {
        "type": "business",
        "company": "uAfrica.com",
        "street_address": "116 Lois Avenue",
        "local_area": "Menlyn",
        "city": "Pretoria",
        "code": "0181",
        "zone": "Gauteng",
        "country": "ZA",
        "lat": -25.7863272,
        "lng": 28.277583
    },
    "collection_contact": {
        "name": "Cornel Rautenbach",
        "mobile_number": "",
        "email": "cornel+sandy@uafrica.com"
    },
    "delivery_address": {
        "type": "residential",
        "company": "",
        "street_address": "10 Midas Ave",
        "local_area": "Olympus AH",
        "city": "Pretoria",
        "code": "0081",
        "zone": "Gauteng",
        "country": "ZA",
        "lat": -25.80665579999999,
        "lng": 28.334732
    },
    "delivery_contact": {
        "name": "",
        "mobile_number": "",
        "email": "cornel+sandyreceiver@uafrica.com"
    },
    "parcels": [
        {
            "parcel_description": "Standard flyer",
            "submitted_length_cm": 20,
            "submitted_width_cm": 20,
            "submitted_height_cm": 10,
            "submitted_weight_kg": 2
        }
    ],
    "opt_in_rates": [],
    "opt_in_time_based_rates": [
        76
    ],
    "special_instructions_collection": "This is a test shipment - DO NOT COLLECT",
    "special_instructions_delivery": "This is a test shipment - DO NOT DELIVER",
    "declared_value": 1100,
    "collection_min_date": "2021-05-21T00:00:00.000Z",
    "collection_after": "08:00",
    "collection_before": "16:00",
    "delivery_min_date": "2021-05-21T00:00:00.000Z",
    "delivery_after": "10:00",
    "delivery_before": "17:00",
    "custom_tracking_reference": "",
    "customer_reference": "ORDERNO123",
    "service_level_code": "ECO",
    "mute_notifications": false
},
      location: "",
      city: "",
      dailyFee: "",
      weeklyFee: "",
      monthlyFee: "",
      currentValue: "",
      // bookingStatus: 'Not Booked',
      enabled1: "",
      itemLength: '',
      itemWidth: '',
      itemHeight: '',
      itemWeight: '',
      deposit: "",
      imageUrls: [],
      itemDescription: "",
      images: [],
      deliveryFee: "",
      delivery: "",
      savedLocations: [],
      formData: {
        street: "",
        city: "",
        state: "",
        zip: "",
      },
      showLoadingForCreateItem: false,
      isLoading: false,
      uploaded: 0,
      menuItems() {
        let menuItems = [
          { icon: "fas fa-user-plus", title: "Sign up", link: "/register" },
          { icon: "fas fa-unlock", title: "Sign in", link: "/login" },
        ];
        if (this.userIsAuthenticated) {
          menuItems = [
            // {
            //   icon: 'fas fa-tachometer-alt',
            //   title: 'Dashboard',
            //   link: '/profile'
            // }
          ];
        }
        return menuItems;
      },
    };
  },
  // async beforeMount() {
  //   const snap = await db.collection("locations").get();

  //   snap.docs.forEach(doc => {
  //     this.savedLocations.push(doc.data());
  //   });
  // },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    error() {
      return this.$store.getters.error;
      e;
    },
    formIsValid() {
      return this.itemName.length > 5 && this.uploaded !== 0;
    },
    formIsValid1() {
      return (
        this.category !== null &&
        this.itemDescription.length > 50 &&
        this.condition !== null
      );
    },
    formIsValid2() {
      return (
        (this.currentValue !== "" && this.dailyFee !== "") ||
        this.weeklyFee !== "" ||
        this.monthlyFee !== ""
      );
    },
    formIsValid3() {
      return (
        (this.city !== '' &&
         this.itemName.length > 5 &&
         this.itemImages.length !== 0 &&
          this.streetName !== "" &&
          this.salesValue !== '' &&
          this.category !== null &&
        this.itemDescription.length > 50 &&
        this.condition !== null
        )
      );
    },
    nameProgress() {
      return Math.min(100, this.itemName.length * 10);
    },
    nameColor() {
      return ["error", "warning", "success"][Math.floor(this.nameProgress / 30)];
    },
    progress() {
      return Math.min(100, this.itemDescription.length * 1.6);
    },
    color() {
      return ["red", "orange", "green"][Math.floor(this.progress / 40)];
    },

    // enabledDeposit() {
    //   return (this.deposit = "00");
    // }
  },

  // mounted() {
  //   var autocomplete = new google.maps.places.Autocomplete(
  //     this.$refs['autocomplete'],
  //     {
  //       bounds: new google.maps.LatLngBounds(
  //         new google.maps.LatLng(45.4215296, -75.6971931)
  //       ),
  //     }
  //   );

  //   autocomplete.addListener('place_changed', () => {
  //     var place = autocomplete.getPlace();

  //     this.showLocationOnTheMap(
  //       place.geometry.location.lat(),
  //       place.geometry.location.lng()
  //     );
  //   });
  // },

  watch: {
    dailyFee: function (val) {
      // if daily fee === 00
      this.dailyFee = val;
      this.recomendedWeekly = val * 4;
      this.recomendedMonthly = val * 12;
    },
    enabledDeposit: function () {
      this.enabledDeposit = "false";
      this.deposit = "";
    },
    // deposit: function() {
    //   this.deposit !== "'00'";
    //   this.enabled = "true";
    // },

    user(value) {
      if (value !== null && value !== undefined) {
        if (this.shouldRedirect) {
          this.$router.push("/dashboard");
          this.$emit("loggedIn");
        } else if (this.addItem) {
          this.welcomeDialog = true;
          this.$emit("loggedIn");
          this.$router.push({ name: "Onboarding", params: { addItem: true } });
        } else {
          this.$emit("loggedIn");
        }
      }
      if (value != null && this.continueAddItemAfterLogin) {
        this.onCreateItem();
      }
    },
  },
  methods: {

     async createShipment() {
    const response = await fetch(`https://api.shiplogic.com/v2/shipments`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ 'e5915f9140684b77853ba67b2e8132da'},
        body: JSON.stringify(this.newShipment)
      })
      console.log('shipment response: ', response)
    return await response.json();
},

    showToast(msg) {
      console.log("fire toast");
      this.snackbar = true;
      this.text = msg;
    },
log(){
if (this.checkbox === false){
  this.checkbox = true
}
else {
  this.checkbox = false
}
},

    async uploadFiles(itemID) {
      this.loading = true;
      return new Promise(async (resolve, reject) => {
        const storage = getStorage();
        const fileNames = [];

        const uploadAttachments = async (attachments, folderName) => {
          const photos = [];

          for (let i = 0; i < attachments.length; i++) {
            const file = attachments[i].file.base64;
            const fileName = `${Date.now()}_${attachments[i].file.name}`;
            console.log(fileName);
            fileNames.push(fileName);

            const storageRef = ref(
              storage,
              `salesItems/${this.$store.state.user.id}/${folderName}/${fileName}`
            );

            console.log(storageRef);

            const snapshot = await uploadString(storageRef, file, "base64");
            const downloadURL = await getDownloadURL(snapshot.ref);

            photos.push({ src: downloadURL });

            console.log(downloadURL);
          }

          return photos;
        };

        const itemImages = await uploadAttachments(this.itemImages, this.itemName);

        // const allPhotos = [...poaPhotos, ...idPhotos, ...selfiePhotos];

        const db = getFirestore();

        const userId = this.$store.state.user.id;
        const usersRef = doc(db, "salesItems", itemID);
        await updateDoc(usersRef, {
          images: itemImages,
          id: itemID
        }).then(() => {
          console.log("Document successfully updated!");

          this.showLoadingForCreateItem = false;
          this.successDialog = true;

          resolve();
        }).catch((err) => {
            //handle error
            this.showLoadingForCreateItem = false;
            this.showToast('Opps! There was an issue uploading your listing. Please try again.');
          });
      });
    },

    // "type": "business",
    //   "company": "uAfrica.com",
    //   "street_address": "116 Lois Avenue",
    //   "local_area": "Menlyn",
    //   "city": "Pretoria",
    //   "code": "0181",
    //   "zone": "Gauteng",
    //   "country": "ZA",
    //   "lat": -25.7863272,
    //   "lng": 28.277583

    initMarker(loc) {
      console.log(loc);
      console.log("location: ", loc);
      for (let i = 0; i < loc.address_components.length; i++) {
        if (loc.address_components[i].types[0] === "locality") {
          this.city = loc.address_components[i].long_name;
        }
        if (loc.address_components[i].types[0] === "street_number") {
          this.streetNumber = loc.address_components[i].long_name;
        }
        if (loc.address_components[i].types[0] === "route") {
          this.streetName = loc.address_components[i].long_name;
        }
        if (loc.address_components[i].types[0] === "postal_code") {
          this.postalCode = loc.address_components[i].long_name;
        }
        if (loc.address_components[i].types[0] === "administrative_area_level_1") {
          this.province = loc.address_components[i].long_name;
        }
        if (loc.address_components[i].types[0] === "country") {
          this.country = loc.address_components[i].short_name;
        }
        if (
          loc.address_components[i].types[0] === "sublocality_level_2" ||
          loc.address_components[i].types[0] === "sublocality_level_1" ||
          loc.address_components[i].types[0] === "sublocality"
        ) {
          this.suburb = loc.address_components[i].long_name;
        }
      }
      this.lat = loc.geometry.viewport.Va.lo
      this.long = loc.geometry.viewport.Ha.lo
    },

    dashboard() {
      this.$router.push("/dashboard");
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    stop() {
      this.$confetti.stop;
      this.$router.push("/dashboard");
    },
    uploadImageAndContinue() {
      this.e4 = 2;
      var files = this.$refs.imgDropZone.getAcceptedFiles();
      var arr = [];
      for (var i in files) {
        arr.push(files[i].dataURL);
      }
      this.imageUrls = arr;
    },
    async uploadImagesAndGetUrls() {
      return new Promise(async (resolve, reject) => {
        // const promises = [];
        var photos = [];
        for (var i in this.imageUrls) {
          var imageUrl = uuid.v1();
          try {
            // save image
            const file = this.imageUrls[i];
            // var metadata = {
            //   contentType: 'image/png',
            // };
            const storage = getStorage();
            const imageRef = ref(storage, `items/${imageUrl}.png`);

            // const snapshot = await uploadString(imageRef, file, metadata);
            const snapshot = await uploadString(imageRef, file, "data_url");
            const downloadURL = await getDownloadURL(snapshot.ref);
            photos.push({ src: downloadURL });
            // promises.push(
            //   uploadBytes(imageRef, file, metadata).then((uploadResult) => {
            //     return getDownloadURL(uploadResult.ref);
            //   })
            // );

            // const photos = await Promise.all(promises);

            // console.log(photos);

            // await updateDoc(docRef, { photosURLs: photos });

            // await imageRef.putString(this.imageUrls[i], 'data_url');
            // var downloadURL = await getDownloadURL(
            //   uploadTask.snapshot.ref
            // ).then((downloadURL) => {
            //   console.log('File available at', downloadURL);
            // });

            console.log(photos);
          } catch (error) {
            console.log(error);
          }
        }
        console.log(photos);
        resolve(photos);
      });
    },

    // async getMinDays() {
    //   if (this.period === "Day(s)") this.minDays = periodLength * 1;
    //   if (this.period === "Week(s)") this.minDays = periodLength * 7;
    //   if (this.period === "Month(s)") this.minDays = periodLength * 30;
    //   return this.minDays;
    // },

    async onCreateItem() {
      // if (!this.formIsValid3) {
      //   return;
      // }
      if (!this.userIsAuthenticated()) {
        // TODO
        this.loginDialog = true;
        this.continueAddItemAfterLogin = true;
      } else {
        this.showLoadingForCreateItem = true;
        var images = await this.uploadImagesAndGetUrls();

        //check if all the required data is present

        const itemData = {
          itemName: this.itemName,
          address: this.streetNumber + ' ' + this.streetName,
          suburb: this.suburb,
          postalCode: this.postalCode,
          province: this.province,
          city: this.city,
          country: this.country,
          lat: this.lat,
          long: this.long,
          deposit: this.deposit,
          period: this.period,
          delivery: this.delivery,
          deliveryFee: this.deliveryFee,
          itemDescription: this.itemDescription,
          price: this.salesValue,
          condition: this.condition,
          collection: this.checkbox,
          category: this.category,
          serialNumber: this.serialNumber,
          itemLength: this.itemLength,
          itemWidth: this.itemWidth,
          itemHeight: this.itemHeight,
          itemWeight: this.itemWeight,
        };

        this.dialog = true;
        this.$store
          .dispatch("createSalesItem", itemData)
          .then((item) => {
           console.log('item: ', item)
           this.uploadFiles(item.id)
          })
          .catch((err) => {
            //handle error
            this.showLoadingForCreateItem = false;
            this.showToast('Opps! There was an issue uploading your listing. Please try again.');
          });
        // this.$confetti.start();
      }
    },

    async remove() {
      this.uploaded > 0 ? this.uploaded-- : (this.uploaded = 0);
    },
    // i need this to add to the item collection.
    async afterComplete(upload) {
      this.uploaded++;
      //var imageUrl = uuid.v1();
      this.isLoading = true;
      // try {
      //   // save image
      //   const file = this.imageUrls[0];
      //   var metadata = {
      //     contentType: "image/png",
      //   };
      //   var storageRef = firebase.storage().ref();
      //   var imageRef = storageRef.child(`items/${imageUrl}.png`);
      //   await imageRef.put(file, metadata);
      //   var downloadURL = await imageRef.getDownloadURL();
      //   this.images.push({ src: downloadURL });
      // } catch (error) {
      //   console.log(error);
      // }
      // this.$refs.imgDropZone.removeFile(upload)
    },
    userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsLogged() {
      if (!this.userIsAuthenticated) {
        return false;
      } else if (this.userIsAuthenticated) {
        return true;
      }
    },
    userIsNotAuthenticated() {
      return this.$store.getters.user == null && this.$store.getters.user == undefined;
    },
    onFilePicked(event) {
      const files = event.target.files;
      for (var i = 0; i < files.length; i++) {
        const filename = files[i].name;
        if (filename.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file!");
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.imageUrls.push(fileReader.result);
        });
        fileReader.readAsDataURL(files[i]);
      }
      console.log(this.imageUrls);
    },
    onPickFile() {
      this.$refs.imgDropZone.click();
    },
  },
};
</script>

<template>
  <div>
    <v-snackbar v-model="snackbar">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Got it!
        </v-btn>
      </template>
    </v-snackbar>
    <v-col cols="12" md="10" offset-md="1" lg="8" offset-lg="2">
      <v-card style="border-radius: 12px" class="mb-16 pt-2" text>
        <center>
          <h1 class="ma-4 secondary--text">New Listing</h1>
        </center>


        <!-- <center>
                <p class="display-1 secondary--text font-weight-bold">
                  Add a description
                </p>
              </center> -->
        <form class="mt-6" @submit.prevent="onCreateItem">
          <v-col cols="12" md="8" offset-md="2" >
            <v-text-field
            v-model="itemName"
            label="Item Name"
            hint="More than 6 characters"
            persistent-hint
            counter
            name="name"
            placeholder="Start typing..."

          >
            <template v-slot:progress>
              <v-progress-linear
                :value="nameProgress"
                :color="nameColor"
                absolute
                height="3"
                width="50px"
              ></v-progress-linear>
            </template>
          </v-text-field>
          <!-- <v-text-field
                  v-model="itemName"
                  minlength="6"
                  hint="More than 6 characters"
                  persistent-hint
                  name="name"
                  color="rgb(34, 34, 34)"
                  counter
                  label="Item Name"
                >
                  <template v-slot:progress>
                    <v-progress-linear
                      :value="nameProgress"
                      :color="nameColor"
                      absolute
                      height="7"
                    ></v-progress-linear>
                  </template>
                </v-text-field> -->

          <br />
          <p class="center">
            Upload Item Images below (At least 1, maximum of 5 Images)
          </p>
          <handy-uploader
            ref="uploader"
            :documentAttachment.sync="itemImages"
            :fileUploaderType="'simple'"
            :maxFileSize="5120"
            :imageCompressor="true"
            :imageCompressLevel="0.4"
            :maxFileCount="5"
            :badgeCounter="true"
            :thumb="true"
            :changeFileName="true"
            :addFileDescription="true"
            :addFileTag="true"
            :tags="['Tag 1', 'Tag 2', 'Tag 3', 'Tag 4']"
            :btnColor="'#8F9CF8'"
            :cardType="'raised'"
            style="border-radius: 12px"
            class="my-8"
          >
          </handy-uploader>

          <p>How much would you like to sell this item for?</p>
          <v-text-field
            id="value"
            v-model="salesValue"
            v-on:keypress="isNumber(event)"
            name="value"
            label="Rand Value"
            class="round"
            suffix=".00"
            maxlength="10"
            outlined
            prefix="R"
            v-bind:focus="focus"
            v-on:focus="focus = false"
            required
          />
          <!-- <vue-dropzone
                  id="customdropzone"
                  ref="imgDropZone"
                  type="file"
                  accept="image/*"
                  :max-number-of-files="5"
                  style="border-radius: 12px !important"
                  :options="dropzoneOptions"
                  @vdropzone-complete="afterComplete"
                  @vdropzone-removed-file="remove"
                /> -->

            <v-select
              v-model="category"
              :items="allCategories"
              label="Select a Category"
              class="round"
              outlined
              color="rgb(34, 34, 34)"
            />

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-textarea
                  v-bind="attrs"
                  v-on="on"
                  v-model="itemDescription"
                  placeholder="Start typing..."
                  loading
                  color="rgb(34, 34, 34)"
                  type="text"
                  :maxlength="max"
                  required
                  outlined
                  hint="between 50 and 500 characters."
                  counter
                  class="round"
                >
                  <!--     <div
                          class="input-group-addon"
                          v-text="(max - itemDescription.length)"
                        /> -->
                  <template v-slot:progress>
                    <v-progress-linear
                      :description="progress"
                      :color="color"
                      :value="progress"
                      absolute
                      height="7"
                    />
                  </template>
                  <template v-slot:label>
                    <div>Describe your Item</div>
                  </template>
                </v-textarea>
              </template>
              <span>Minimum of 50 characters needed</span>
            </v-tooltip>

            <v-select
              v-model="condition"
              :items="allConditions"
              label="Item Condition"
              class="round"
              outlined
              color="rgb(34, 34, 34)"
            />

            <v-text-field
              v-model="serialNumber"
              label="Item Serial Number*"
              class="round"
              outlined
              placeholder="Serial Number"
            />
            <p class="font-italic text-caption mt-n6">*If applicable</p>

            <p>Address (Precise location will be hidden):</p>
            <gmap-autocomplete
              class="gmap "
              @place_changed="initMarker"
            ></gmap-autocomplete>
            <v-checkbox
            class="mb-4"

            label="Buyer can collect item from address after payment"
            color="primary"
            @change="log()"
            value="false"
            hide-details
          >

          </v-checkbox>

<v-row>
  <v-col class="pb-0" cols="6" lg="3" xl="3">
    <v-text-field
    v-model="itemLength"
    v-on:keypress="isNumber(event)"
    label="Length"
    class="round"
    suffix="cm"
    maxlength="10"
    outlined
    v-bind:focus="focus"
    v-on:focus="focus = false"

  />
  </v-col>
  <v-col class=" pb-0" cols="6" lg="3" xl="3">
    <v-text-field
    v-model="itemWidth"
    v-on:keypress="isNumber(event)"
    label="Width"
    class="round"
    placeholder="0"
    suffix="cm"
    maxlength="10"
    outlined
    v-bind:focus="focus"
    v-on:focus="focus = false"

  />
  </v-col>
  <v-col class="pt-0 pb-0" cols="6" lg="3" xl="3">
    <v-text-field
    v-model="itemHeight"
    v-on:keypress="isNumber(event)"
    label="Height"
    class="round"
    suffix="cm"
    maxlength="10"
    outlined
    v-bind:focus="focus"
    v-on:focus="focus = false"

  />
  </v-col>
  <v-col class="pt-0 pb-0" cols="6" lg="3" xl="3">
    <v-text-field
    v-model="itemWeight"
    v-on:keypress="isNumber(event)"
    label="Weight"
    class="round"
    suffix="kg"
    maxlength="10"
    outlined
    v-bind:focus="focus"
    v-on:focus="focus = false"

  />
  </v-col>
</v-row>

        <v-row class="center">
        <v-btn
        :disabled="showLoadingForCreateItem || !formIsValid3"
        @click="onCreateItem()"
        class="ebtn ma-6"


       block
        color="accent"
        elevation="8"
        :loading="showLoadingForCreateItem"
      >
        Submit
      </v-btn>
    </v-row>
          </v-col>



        </form>





        <!-- <form @submit.prevent="onCreateItem">
          <v-row>
            <v-col cols="12" md="8" offset-md="2">

            </v-col>
          </v-row>
        </form> -->


        <!-- STEP 4 -->

      </v-card>
    </v-col>

    <v-overlay v-if="showLoadingForCreateItem">
      <v-img :src="require('@/assets/svgs/gondola2.svg')" />
      Uploading your item...
    </v-overlay>

    <v-dialog
      v-model="successDialog"
      max-width="450px"
      persistent
      transition="dialog-bottom-transition"
    >
      <template>
        <v-card style="border-radius: 12px !important" class="text-center">
          <v-card-title
            style="
              padding: 0px 24px !important;
              font-size: 1em !important;
              line-height: 1.43;
            "
            class="text-center black--text"
          >
            <!-- <v-icon
                                  small
                                  color="black"
                                  @click="startDialog = false"
                                  >mdi-close</v-icon
                                > -->
            <p class="my-3 ml-auto mr-auto">Woohoo!</p>
          </v-card-title>
          <v-divider></v-divider>
          <div class="grid">
            <v-img
              size="small"
              width="300px"
              height="300px"
              :src="require('@/assets/svgs/celebrate-1.svg')"
            ></v-img>
          </div>
          <v-card-text
            style="
              font-size: 16px !important;
              line-height: 20px !important;
              color: rgb(34, 34, 34) !important;
            "
          >
            Congrats on submitting your Item! We will let you know when someone purchases it.
          </v-card-text>

          <v-card-actions class="mt-n9">
            <v-btn
              block
              class="btn white--text"
              style="border-radius: 8px !important"
              @click="dashboard()"
              color="accent"
            >
              View Dashboard
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      v-model="signupDialog"
      scrollable
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <SignupComponent
        :shouldRedirect="false"
        @loggedIn="signupDialog = false"
        :fromPage="false"
        :addItem="true"
        @changeDialog="
          signupDialog = false;
          loginDialog = true;
        "
      />
    </v-dialog>

    <v-dialog
      v-model="loginDialog"
      scrollable
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <LoginComponent
        :shouldRedirect="false"
        :fromPage="false"
        :addItem="true"
        @loggedIn="loginDialog = false"
        @changeDialog="
          loginDialog = false;
          signupDialog = true;
        "
      />
    </v-dialog>
    <v-dialog style="border-radius: 12px !important" v-model="welcomeDialog" width="500">
      <v-card style="border-radius: 12px !important" class="text-center">
        <v-card-title
          style="
            padding: 0px 24px !important;
            font-size: 1em !important;
            line-height: 1.43;
          "
          class="text-center black--text"
        >
          <!-- <v-icon small color="black" @click="welcomeDialog = false"
            >mdi-close</v-icon
          > -->
          <p class="my-3 ml-auto mr-auto">Get Started</p>
        </v-card-title>
        <v-divider></v-divider>

        <base-img
          :src="require('@/assets/logos/icon1.svg')"
          class="mb-5 mt-15 mx-auto"
          contain
          height="100"
          width="382"
        />

        <p class="heading my-3 ml-auto mr-auto">Welcome to Strapp</p>
        <v-card-text
          style="
            font-size: 16px !important;
            line-height: 20px !important;
            color: rgb(34, 34, 34) !important;
          "
        >
          Experience new ways of participating with your community
        </v-card-text>
        <!-- <v-card-text>
          Users will not be able to see your photo until a booking has been
          made.
        </v-card-text> -->

        <!-- <v-divider></v-divider> -->

        <v-card-actions>
          <v-btn
            v-if="addItem"
            block
            class="btn white--text"
            style="border-radius: 8px !important"
            @click="onCreateItem"
            color="black"
          >
            Finish Submitting Item
          </v-btn>

          <v-btn
            v-else
            block
            class="btn white--text"
            style="border-radius: 8px !important"
            @click="(verifyDialog = true), (startDialog = false)"
            color="black"
          >
            Next
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style>
/* TODO: set width for screen sizes  */
/* .dz-progess{

} */
.dropzone .dz-preview.dz-image-preview {
  background: white;
  z-index: 2;
  margin: 16px;
}

.round {
  border-radius: 12px !important;
}

.bbtn {
  display: inline-block;
  font-size: 14px !important;
  line-height: 20px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  padding: 0.8rem 1.8rem;
  background: transparent !important;
  color: rgb(34, 34, 34) !important;
  width: 25px;
  margin-top: 2rem;
  cursor: pointer;
  transition: 0.5s;
  transition: all 0.3s ease 0s;
}

.bbtn:hover {
  opacity: 0.8;
  border-radius: 18px;
  box-shadow: 0px 5px 10px #b83bf1;
  transform: translateY(-7px);
  color: #b83bf1;
  background-color: #b83bf1;
}

.ebtn {
  display: inline-block;
  font-size: 14px !important;
  line-height: 20px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  padding: 0.8rem 1.8rem;
  /* background: rgb(34, 34, 34) !important;
  color: rgb(255, 255, 255) !important; */
  width: 25px;
  margin-top: 2rem;
  cursor: pointer;
  transition: 0.5s;
  transition: all 0.3s ease 0s;
}

.ebtn:hover {
  opacity: 0.8;
  border-radius: 18px;

  transform: translateY(-7px);
}

.grid {
  display: grid;
  place-items: center;
}

.cbutton {
  padding: 1rem 4rem;
  border-radius: 100rem;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.cbutton:hover {
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}

.abutton {
  padding: 1rem 4rem;
  border-radius: 100rem;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.abutton:hover {
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}



.center {
  display: grid;
  place-items: center;
}

.btn:hover {
  opacity: 0.8;
  border-radius: 18px;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
  color: #81abfc;
  background-color: #7552b9;
}

.gmap {
  background-color: white;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  width: 100%;
}

@import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");
</style>
